<nav
  class="ui-sidebar"
  [class.ui-sidebar--collapsed]="collapsed()"
  [class.ui-sidebar--mobile-open]="mobileOpen()"
  [attr.aria-label]="'Navigation principale'"
>
  @if (brand()) {
    <header class="ui-sidebar__brand" [class.ui-sidebar__brand--collapsed]="collapsed()">
      <span class="ui-sidebar__logo" aria-hidden="true">{{ brandIcon() }}</span>
      @if (visibleLabel()) {
        <span class="ui-sidebar__name">{{ brand() }}</span>
        <button
          type="button"
          class="ui-sidebar__toggle"
          aria-label="Masquer le menu"
          (click)="toggleCollapsed.emit()"
        >
          <ui-icon name="chevron-left" size="sm" />
        </button>
      }
    </header>
  }

  @if (collapsed()) {
    <button
      type="button"
      class="ui-sidebar__toggle ui-sidebar__toggle--collapsed"
      aria-label="Afficher le menu"
      (click)="toggleCollapsed.emit()"
    >
      <ui-icon name="chevron-right" size="sm" />
    </button>
  }

  <ul class="ui-sidebar__list">
    @for (item of items(); track item.label; let i = $index) {
      <li class="ui-sidebar__item">
        @if (item.children?.length) {
          <button
            type="button"
            class="ui-sidebar__link"
            [class.ui-sidebar__link--open]="isOpen(i)"
            [attr.aria-expanded]="isOpen(i)"
            (click)="toggleGroup(i)"
          >
            @if (item.icon) {
              <span class="ui-sidebar__icon"><ui-icon [name]="item.icon" /></span>
            }
            @if (visibleLabel()) {
              <span class="ui-sidebar__label">{{ item.label }}</span>
            }
            <span class="ui-sidebar__chevron">
              <ui-icon [name]="isOpen(i) ? 'chevron-down' : 'chevron-right'" size="sm" />
            </span>
          </button>

          @if (isOpen(i)) {
            <ul class="ui-sidebar__sublist">
              @for (child of item.children; track child.label) {
                <li>
                  <a
                    class="ui-sidebar__sublink"
                    [routerLink]="child.link"
                    routerLinkActive="is-active"
                    (click)="onItemClick()"
                  >
                    {{ child.label }}
                  </a>
                </li>
              }
            </ul>
          }
        } @else {
          <a
            class="ui-sidebar__link"
            [routerLink]="item.link"
            routerLinkActive="is-active"
            (click)="onItemClick()"
          >
            @if (item.icon) {
              <span class="ui-sidebar__icon"><ui-icon [name]="item.icon" /></span>
            }
            @if (visibleLabel()) {
              <span class="ui-sidebar__label">{{ item.label }}</span>
            }
            @if (item.count) {
              <span class="ui-sidebar__count">{{ item.count }}</span>
            }
          </a>
        }
      </li>
    }
  </ul>
</nav>
